import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('MeasurementUnitService', MeasurementUnitService);

  MeasurementUnitService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'TranslationModalService',
    'WindowModalService',
  ];

  function MeasurementUnitService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    TranslationModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'companies';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getMeasurementUnits: getMeasurementUnits,
      getMeasurementUnit: getMeasurementUnit,
      saveMeasurementUnit: saveMeasurementUnit,
      openMeasurementUnitModal: openMeasurementUnitModal,
      openMeasurementUnitTranslations: openMeasurementUnitTranslations,
      changeMeasurementUnitStatus: changeMeasurementUnitStatus,
      deleteMeasurementUnit: deleteMeasurementUnit,
      setMeasurementUnitsByProductType: setMeasurementUnitsByProductType,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getMeasurementUnits(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      var url = apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/measurement_units';

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getMeasurementUnit(id, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      var url =
        apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/measurement_units/' + id;

      return RestResource.request(
        'get',
        url,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveMeasurementUnit(measurementUnit, language) {
      var url = apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/measurement_units';
      var method = 'post';

      if (measurementUnit.id) {
        // edit
        url += '/' + measurementUnit.id;
        method = 'put';
      }

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = !measurementUnit.id ? 'UNIT_OF_MEASURE_ADDED' : 'UNIT_OF_MEASURE_MODIFIED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { measurement_unit: measurementUnit, lang: lang },
        success,
        failure
      );
    }

    function openMeasurementUnitModal(
      measurementUnit,
      defaultLanguage,
      additionalLanguages,
      mode,
      successCallback
    ) {
      var templateUrl = './app/ajs/measurement-units/modals/measurement-unit-detail-modal.html';

      var originalItem = angular.copy(measurementUnit);

      var modalParams = {
        title: 'UNIT_OF_MEASURE_DETAILS',
        item: originalItem,
        mode: mode,
        defaultLanguage: defaultLanguage,
        additionalLanguages: additionalLanguages,
        preventModalClose: true,
      };

      // if (!measurementUnit.id){
      //     modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      var confirmCallback = function (response) {
        if (measurementUnit.id) {
          // Edit
          measurementUnit.name = response.name;
          measurementUnit.description = response.description;
          measurementUnit.symbol = response.symbol;
          measurementUnit.allow_decimals = response.allow_decimals;
          measurementUnit.increment_value = response.increment_value;
          measurementUnit.product_types = response.product_types;

          return utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openMeasurementUnitTranslations(measurementUnit, additionalLanguages) {
      var template = './app/ajs/measurement-units/modals/measurement-unit-detail-translation.html';

      var modalParams = {
        title: measurementUnit.name,
        item: measurementUnit,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getMeasurementUnit(itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (measurementUnit, language) {
        return saveMeasurementUnit(measurementUnit, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function changeMeasurementUnitStatus(measurementUnit) {
      let url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/measurement_units/' +
        measurementUnit.id +
        '?set_status=true';

      let newStatus = measurementUnit.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, measurementUnit);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function deleteMeasurementUnit(measurementUnit, successCallback) {
      let url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/measurement_units/' +
        measurementUnit.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'SURE_TO_DELETE_UNIT_OF_MEASURE',
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'UNIT_OF_MEASURE_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function setMeasurementUnitsByProductType(measurementUnits, productType) {
      var array = [];
      measurementUnits.forEach(function (measurementUnit) {
        var found = false;
        for (var i = 0; i <= measurementUnit.product_types.length; i++) {
          if (measurementUnit.product_types[i] === productType) {
            found = true;
            break;
          }
        }

        if (found) {
          array.push(measurementUnit);
        }
      });

      return array;
    }
  }
})();
